module.exports = __webpack_public_path__ + "static/p3-2ea5d8566e6139d66be4ac00ea5cec9d.svg";